import { DollarSign, Layers } from 'lucide-react'

import ResponsiveModalDrawer from '@/common/ResponsiveModalDrawer'
import { cn } from '@/theme/utils'
import { UiButton } from '@/ui/UiButton'

export default function ChooseBecomeValidatorFlowModal({
  open,
  onOpenChange,
  onSelect,
}: {
  open: boolean
  onOpenChange: (next: boolean) => void
  onSelect: (mode: 'shards' | 'amount') => void
}) {
  return (
    <ResponsiveModalDrawer
      open={open}
      onOpenChange={onOpenChange}
      title={
        <div className='mr-4'>
          <div className='text-foreground mb-2'>Become a Validator</div>
          <div className='text-muted-foreground text-sm'>
            Choose how you want to stake to create the validator
          </div>
        </div>
      }
      content={
        <div className='mt-4 grid grid-cols-1 gap-3 sm:grid-cols-2'>
          <button
            type='button'
            onClick={() => onSelect('shards')}
            className={cn(
              'cursor-pointer rounded-lg px-4 py-5 text-left transition',
              'bg-primary/5 hover:bg-primary/10',
              'flex min-h-24 items-start gap-4',
            )}
          >
            <div className='shrink-0 pt-1'>
              <Layers className='text-primary h-6 w-6' />
            </div>
            <div className='flex-1'>
              <div className='text-sm font-semibold'>Use Shards</div>
              <div className='text-muted-foreground mt-2 text-xs'>
                Select one or more Shards to aggregate stake and become a
                validator.
              </div>
            </div>
          </button>

          <button
            type='button'
            onClick={() => onSelect('amount')}
            className={cn(
              'cursor-pointer rounded-lg px-4 py-5 text-left transition',
              'bg-primary/5 hover:bg-primary/10',
              'flex min-h-24 items-start gap-4',
            )}
          >
            <div className='shrink-0 pt-1'>
              <DollarSign className='text-primary h-6 w-6' />
            </div>
            <div className='flex-1'>
              <div className='text-sm font-semibold'>Use Amount</div>
              <div className='text-muted-foreground mt-2 text-xs'>
                Stake a specific amount of BRIDGE (coin) directly to create the
                validator.
              </div>
            </div>
          </button>
        </div>
      }
      footer={
        <div className='flex gap-2'>
          <UiButton
            variant='outline2'
            className='h-12 flex-1'
            onClick={() => onOpenChange(false)}
          >
            Cancel
          </UiButton>
        </div>
      }
      modalProps={{ className: 'bg-card text-foreground rounded-lg max-w-xl' }}
      drawerProps={{ className: 'bg-card text-foreground rounded-lg' }}
    />
  )
}
